import { withWindow } from '@shared/utils/withWindow';

export const greetingCardBaseUrl = new URL(withWindow(global => `${global.location.origin}/card`, 'https://withjoy.com/card')).toString();
